import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPioneerdjComponent } from './simple-icons-pioneerdj.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPioneerdjComponent ],
    exports:      [ SimpleIconsPioneerdjComponent ],
    bootstrap:    []
})
export class SimpleIconsPioneerdjModule {}
